export default __webpack_public_path__ + "static/media/prime-subtitle-img.b9ab70f3.png";